import { Injectable } from '@angular/core';
import { Session } from '@models/Sessions/Session';
import { ConfigService } from '@services/config.service';
import { map } from 'rxjs/operators';

import { SessionsRequestService } from './sessions.request.service';

@Injectable()
export class MoveIdeasService {
  constructor(
    private sessions: SessionsRequestService,
    private config: ConfigService,
  ) {}

  public potentialTargetSessions(origin: Session) {
    return this.sessions.getAll().pipe(
      map(sessions => {
        return sessions.filter(
          session =>
            session._id.toString() !== origin._id.toString() &&
            !session.config.cluster &&
            this.config.permissions.session.data.ideas.post(session) &&
            this.config.permissions.session.config.participants.add(session),
        );
      }),
    );
  }
}
